import React from 'react'
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import DashboardAgenda from '../../Components/Admin/DashboardAgenda/DashboardAgenda'
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad'
import MyPlanPanel from '../../Components/Admin/MyPlanPanel/MyPlanPanel'
import NetSalesOverview from '../../Components/Admin/NetSalesOverview/NetSalesOverview'
export default function Main() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='containerMain'>
                    <div className='deFLexMain dashboardOverviewRow'>
                        <CardsCantidad />
                        <DashboardAgenda />
                    </div>
                    <NetSalesOverview />
                    <MyPlanPanel />


                </div>
            </section>
        </div>
    )
}
